// removed by extract-text-webpack-plugin
module.exports = {"container":"container_2mgdh","button":"button_2Ag0g","holder":"holder_2Cosy","gap":"gap_1dLdA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cheat_panel/style.scss
// module id = 521
// module chunks = 0